import React from "react";
import "./Surrounding.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Surroundingimages from "../../Media/Surrounding Cibubur/Surrounding";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6281325283186&text=Halo%20Reza,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Wisata%20(Surrounding%20Area)%20https://perumahankotawisata.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="surrounding" className="surrounding">
      <div className="slider-regia">
        <Slider {...settings1}>
          {Surroundingimages.map((image, index) => (
            <img className="imagecard" key={index} src={image} alt={image} />
          ))}
        </Slider>
      </div>
      <div className="container-fasilitas">
        <h1>Kota Wisata Surounding Area</h1>
        <hr color="#091C34" />
        <div className="container-desk">
          <div className="desksurrounding">
            Selain menawarkan fasilitas yang menarik, Kota Wisata juga
            dikelilingi dengan berbagai macam fasilitas umum, seperti lingkungan
            pendidikan, kesehatan, tempat hiburan serta akses transportasi guna
            mempermudah penghuni memenuhi kebutuhannya
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Living World Mall
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Transpark Cibubur
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Mall Ciputra Cibubur
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Permata Cibubur Hospital
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Mitra Keluarga Hospital
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Cibubur Junction
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Grebang Tol Jatikarya
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>&nbsp;&nbsp;Eka Hospital</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "#4d4d4d"}}>
                &nbsp;&nbsp;Gerbang Tol Narogong
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
